import React, { FC } from 'react';
import { TWCPage } from '@components';

import { alertDetailsPageTestIDs } from '@constants';
import { Route } from '@types';

import { AlertDetailsPageContent } from './AlertDetailsPageContent/AlertDetailsPageContent';

type AlertDetailsPageProps = {
  route: Route;
};

export const AlertDetailsPage: FC<AlertDetailsPageProps> = ({ route }) => {
  const { index, alerts } = route.params ?? {};

  return (
    <TWCPage
      childIds={[alertDetailsPageTestIDs.alertDetailsFocus]}
      firstFocus={alertDetailsPageTestIDs.alertDetailsFocus}
      hasBackground={false}
      pageID={alertDetailsPageTestIDs.alertDetailsPage}
    >
      <AlertDetailsPageContent alertDetails={alerts} initialIndex={index} />
    </TWCPage>
  );
};
